import React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import Modal from '@/components/modal/Modal';
import { RegularText, MediumText } from '@/lib/Text';
import { Row } from '@/lib/utils';
import { colors } from '@/lib/colors';

dayjs.locale('ko');

interface ModalNoticeConfirmProps {
    isEdit: boolean;
    publishAt: string | null;
    targetLabel: string;
    onCancel: () => void;
    onConfirm: () => void;
}

const ModalNoticeConfirm = ({ isEdit, publishAt, targetLabel, onCancel, onConfirm }: ModalNoticeConfirmProps) => {
    return (
        <Modal
            onClose={onCancel}
            whiteViewWidth={500}
            borderRadius={20}
            isCloseButton={false}
            isWhiteOverFlowScroll={false}
        >
            <div className="px-[32px] py-[36px]">
                <div className="mb-[10px]">
                    <MediumText fontSize={22} lineHeight={32} color={colors.Text_1} letterSpacing={-0.5}>
                        {isEdit ? '공지를 수정할까요?' : '공지를 등록할까요?'}
                    </MediumText>
                </div>
                <div className={publishAt ? 'mb-[10px]' : 'mb-[73px]'}>
                    <RegularText fontSize={22} lineHeight={32} color={colors.Text_1} letterSpacing={-0.5}>
                        {isEdit
                            ? '수정된 내용은 회원에게 바로 반영됩니다.'
                            : `등록하면 이 공지가 ${targetLabel}에게 공유돼요.`}
                    </RegularText>
                </div>
                {publishAt && (
                    <div className="mb-[73px]">
                        <RegularText fontSize={22} lineHeight={32} color={colors.primary} letterSpacing={-0.7}>
                            {dayjs(publishAt).format('YYYY.MM.DD(dd) HH:mm')} 예약 {isEdit ? '등록' : '등록'}
                        </RegularText>
                    </div>
                )}
                <Row className="gap-[16px] items-end flex justify-end">
                    <button
                        className="h-[44px] w-[160px] rounded-[12px] bg-[#F2F4F6] hover:bg-[#E8EAED] transition-colors justify-center items-center"
                        onClick={onCancel}
                    >
                        <RegularText fontSize={16} lineHeight={16} color={colors.Text_1}>
                            취소
                        </RegularText>
                    </button>
                    <button
                        className="h-[44px] w-[160px] rounded-[12px] bg-primary hover:bg-blue-600 transition-colors justify-center items-center"
                        onClick={onConfirm}
                    >
                        <RegularText fontSize={16} lineHeight={16} color="white">
                            {isEdit ? '수정하기' : '등록하기'}
                        </RegularText>
                    </button>
                </Row>
            </div>
        </Modal>
    );
};

export default ModalNoticeConfirm;
